<template>
   
   <div class="container mt-2 justify-content-center">
    <div class="row ">
            <div class="col-12 mt-2">
 
 
<input type="text" v-model="searchStudent" class="form-control" placeholder="ძებნა..."/>
<!-- <button type="button" class="btn btn-outline-success"   @click="exportToExcel()"><i class='bx bxs-file-export'></i></button>  -->
 
 
<div id="table-container">

                <table class="table">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col">სახელი გვარი</th>
      <th scope="col">ბრძანების თარიღი</th>
      <th scope="col">ბრძანების ნომერი</th>
      <th scope="col">პროგრამა</th>
      <th scope="col">პირადი ნომერი</th> 
      <th scope="col">მობილური</th>
      <th scope="col">UG კოდი</th>
      <th scope="col">პაროლი</th> 
      <th scope="col">სტატუსი</th>

    </tr>
  </thead>
  <tbody>
    <tr v-for="student in filteredStudent" :key="student.studentID">
      <th scope="row">{{ student.studentID }}</th>
      <td>{{ student.fname }} {{ student.lname }}</td>
      <td>{{ student.student_statuses.length>0?student.student_statuses[0].order_date:'' }}</td>
      <td>{{ student.student_statuses.length>0?student.student_statuses[0].order_number:'' }}</td>
      <td>{{ student.student_statuses.length>0?student.student_statuses[0].programs.program_name:''  }}</td>
      <td>{{ student.pn }}</td>
      <td>{{ student.phone }}</td>
     <td>{{ student.code }}</td>
      <td>{{ student.pass_backup }}</td> 
      <td>{{ student.student_statuses.length?student.student_statuses[0].status_reason.reason:'' }}</td>
      <td >
 
        <button v-if="(student.student_statuses[0].status_reason.reasonID==1 || student.student_statuses[0].status_reason.reasonID==6 || student.student_statuses[0].status_reason.reasonID==7) && (this.$store.state.user.positionID==1 || this.$store.state.user.positionID==6)" type="button" class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#chooseTemplate" @click="chooseTemplate(student.studentID)"><i class='bx bxs-file-doc'></i></button> 
      </td>
      <td>
        <button v-if="this.$store.state.user.positionID==1 || this.$store.state.user.positionID==6" type="button" class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="addStatus(student.studentID)"><i class='bx bxs-edit-alt'></i></button> 
      </td>
      <td>
        <button v-if="this.$store.state.user.positionID==1 || this.$store.state.user.positionID==6"  type="button" class="btn btn-outline-success"   @click="viewAndEditStudentProfile(student.studentID)"><i class='bx bx-user-circle'></i></button> 
      </td>
      <td>
        <button v-if="this.$store.state.user.positionID==1"  type="button" class="btn btn-outline-success"   @click="deleteStudent(student.studentID)"><i class='bx bx-message-x' ></i></button> 
      </td>
    </tr>
 
  </tbody>
</table>
</div>
            </div>

    </div>
   </div>
   <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
      
        <div class="mb-3 mt-3">
   

          <div class="mb-3">
 

          <select class="form-control" v-model="reasonID">

          <option value="0">აირჩიეთ სტატუსი...</option>

          <option v-for="reason in statusReasons" :key="reason.reasonID" :value="reason.reasonID">{{ reason.reason }}</option>
          </select>
          </div>  


          <div class="mb-3" v-if="reasonID==6 || reasonID==1 || statuses.length==0">
 
       <select class="form-control" v-model="programID">

        <option value="0">აირჩიეთ პროგრამა...</option>

        <option v-for="program in programs" :key="program.programID" :value="program.programID">{{ program.program_name }} ({{ program.program_types.program_type }})</option>
       </select>
        </div>

        <div class="mb-3"  v-if="reasonID==6 || reasonID==1 || statuses.length==0">
          <p>პროგრამის დაწყება</p>
        <input type="date" class="form-control"    v-model="start_date">
        </div>


        <div class="mb-3"  v-if="reasonID==6 || reasonID==1 || statuses.length==0">
          <p>პროგრამის დასრულება</p>
        <input type="date" class="form-control"   v-model="end_date">
        </div>

            
            <div class="mb-3">

            <input type="text" class="form-control"  placeholder="ბრძანების ნომერი" v-model="orderNum">
            </div>

            <div class="mb-3">

            <label for="start">ბრძანების თარიღი:  </label> 

            <input type="date"  class="form-control" v-model="order_date"/>
            </div>
                    
        

      </div>
      </div>
      <div class="modal-footer">
        <button   type="button" class="btn btn-success" @click="saveStatus()">შენახვა</button>
      
      
      </div>

    
        <table v-if="statuses.length>0" class="table  text-center" > 
          <tr v-for="status in statuses" :key="status.statusID">
            <td>{{ status.status_reason.reason }}</td>
            <td>{{ status.order_number }}</td>
            <td>{{ status.order_date }}</td>
            <td><button type="button" class="btn btn-outline-success" @click="deleteStatus(status.statusID)"><i class='bx bx-x'></i></button></td>
          </tr>
        </table>

       


    </div>
  </div>
</div>

<div class="modal fade" id="chooseTemplate" tabindex="-1" aria-labelledby="chooseTemplateLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
 
        <div class="d-grid mt-3">
          <button class="btn btn-warning" @click="printTemplate(1,chooseTemplateStudentID)">ფორმა 26</button>
        </div>
        <div class="d-grid mt-3">
          <button class="btn btn-warning" @click="printTemplate(2,chooseTemplateStudentID)">ცნობა სტუდენტის სტატუსის შესახებ</button>
        </div>
        <div class="d-grid mt-3">
          <button class="btn btn-warning" @click="printTemplate(3,chooseTemplateStudentID)">ცნობა სწავლების საფასურის მითითებით</button>
        </div>
      
        
       

        </div>
      </div>
  </div>
</div>

</template>
<script>
import HttpRequests from '../httpRequests/httpRequests'

const httpRequests=new HttpRequests()
export default{

   data(){

     return{

         studentslist:[],
         searchStudent:'',
         filteredStudent:[],
         statusReasons:[],
         reasonID:0,
         orderNum:null,
         order_date:null,
         chosenStudent:0,
         statuses:[],
         programID:0,
         programs:[],
         start_date:null,
         end_date:null,
         chooseTemplateStudentID:0


     }

   },

   watch:{
    searchStudent(val){
       if(val!=''){

           this.filteredStudent=this.studentslist.filter(o=>o.fname.includes(val) ||  o.lname.includes(val) || o.pn.includes(val))

       }else{

         this.filteredStudent=this.studentslist
       }

     }


   },
   mounted(){

     httpRequests.getStudentsList().then(response=>{
 
       this.studentslist=response.data
       this.filteredStudent=response.data
     })


     httpRequests.getReasons().then(response=>{

      this.statusReasons=response.data
     })


     httpRequests.getPrograms().then(response=>{

        this.programs=response.data
        })



      


   

   },
   methods:{

    printTemplate(templateType,studentID){

      window.open('https://api.ugcollege.ug.edu.ge/public/api/printTemplate?templateType='+templateType+'&&studentID='+studentID+'&&token='+localStorage.getItem('token'),'_blank')

    },


    chooseTemplate(studentID){

      this.chooseTemplateStudentID=studentID

    },

    exportToExcel() {
     

    
    },


    viewAndEditStudentProfile(studentID){

      window.location.href='/#/editStudentInfo/'+studentID
    },


    deleteStudent(studentID){
      if(confirm('ნამდვილად გსურთ წაშლა?')){

      httpRequests.deleteStudent(studentID).then(()=>{
        location.reload()
      })
}
    },

    deleteStatus(statusID){

      if(confirm('ნამდვილად გსურთ წაშლა?')){

        httpRequests.deleteStatus(statusID).then(()=>{
          location.reload()
        })
      }

    },


    addStatus(studentID){


        this.chosenStudent=studentID


        httpRequests.getStudentsStatuses(studentID).then(response=>{

          this.statuses=response.data
      })

    },


    saveStatus(){

      httpRequests.addStatus(this.reasonID,this.orderNum,this.order_date,this.chosenStudent,this.programID,this.start_date,this.end_date).then(()=>{
        location.reload()
      })

    }

   }



}

</script>